'use client';

export const SaleIcon = () => {
  return (
    <svg
      viewBox='0 0 20 20'
      width='1.2em'
      height='1.2em'
      className='mr-2 h-5 w-5 -translate-y-px drop-shadow'
    >
      <path
        fill='currentColor'
        d='M8.737 5.31L6.609 8.046a.5.5 0 0 1-.619.14L3.865 7.123a1.5 1.5 0 1 0-1.672.845l1.692 8.04A1.25 1.25 0 0 0 5.11 17h9.782a1.25 1.25 0 0 0 1.224-.992l1.692-8.04a1.5 1.5 0 1 0-1.672-.845L14.01 8.186a.5.5 0 0 1-.619-.14l-2.128-2.737a1.5 1.5 0 1 0-2.526 0M10 14a1.5 1.5 0 1 1 0-3a1.5 1.5 0 0 1 0 3'
      ></path>
    </svg>
  );
};
